import React from "react";
import { Navbar, Container } from "react-bootstrap";
import LogoLink from "../../atoms/LogoLink";
import styles from "./Header.module.scss";

type Props = {};

const Header: React.FC<Props> = (props: Props) => {
  return (
    <Navbar sticky="top" className={styles.header}>
      <Container>
        <Navbar.Brand>
          <LogoLink />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default Header;
